import * as React from 'react';
import styles from './Content.module.css';

function Face() {

  const [backgroundColour, setBackgroundColour] = React.useState("#1700c7");

  function handleColorChange(input) {
    const lightness = getLightnessFromHex(input);
    const oppositeColor = lightness > 60 ? 'black' : 'white';

    document.documentElement.style.setProperty('--main-bg-color', input);
    document.documentElement.style.setProperty('--opposite-color', oppositeColor);

    setBackgroundColour(input); // THIS triggers re-render
  }


  return (
    <main className={styles.printPage}>

      <div className={styles.printContent}>


        <header />

        <div className={styles.container}>
          
          <h1 class="inverted">SZYMO.NET</h1>
          <hr />
          <h2>Hi I'm Szymon</h2>
          <sub>Vancouver | 20 | Computer Science Student</sub>

          <p>I love game design/development and jazz (especially Louis Cole)</p>






          <h2>My cats 🥰</h2>
          <hr />

          <div class="cats">
            <div class="cats-left">
              {/* <img src="mumba and ginger.jpg"></img> */}
              <img src="ginger.jpg"></img>
              <div></div>
              <img src="mumba and ginger 2.jpg"></img>
            </div>
            <div class="cats-right">
              These are my cats!
              <p>Ginger (white and orange one) is 3 years old and super hyper. She has constant zoomies and loves to go under things, like blankets, tubes, and bags. She loves laying flat on her chest</p>
              <p>Mumba (black one) is also 3 years old but is the opposite of Ginger. He is super soft, loves to cuddle, and use scratchers. His favourite thing in the world is food. When its time to feed them, Mumba gets so excited he starts running around in circles in the kitchen</p>
            </div>


          </div>

          <h2>Music I like</h2>
          <hr />
          <p>Click the album covers or I click you (this is a threat)</p>
          <div class="music">
            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=vozK-7PS1mk",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273b2932fc2d4c8f8621b13f375"></img>
              </button>
              <span class="inverted">SICK OF IT</span>
              <sub>femtanyl</sub>
            </div>



            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=b524HO-CS4U",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273b5a7cac5f838dcd77512037d"></img>
              </button>
              <span class="inverted">メトロノーム</span>
              <sub>toe</sub>
            </div>

            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=eMjUKsi2evg",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b2739d9bf3fd5ba6d618d163b3f7"></img>
              </button>
              <span class="inverted">Plate</span>
              <sub>Genevieve Artadi</sub>
            </div>



            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=u-dicKzcCF0",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273d1f513f8397d1952f28cf6a4"></img>
              </button>
              <span class="inverted">Weird Moments</span>
              <sub>Louis Cole</sub>
            </div>



            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=F5EFsUU7RRA",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273b752bbaa0dd7578b736f7cc1"></img>
              </button>
              <span class="inverted">Early Summer</span>
              <sub>Ryo Fukui</sub>
            </div>

            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=hh9IPPSi3c4",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b27390ee068042e6372064a1f4c5"></img>
              </button>
              <span class="inverted smaller-text">What Is This Thing Called Love</span>
              <sub>Jesus Molina</sub>
            </div>



            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=TUHakoxcwTc",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273dea0b4b4bba4b0ec8329fca9"></img>
              </button>
              <span class="inverted">Aliso 2023</span>
              <sub>David Binney</sub>
            </div>



            <div class="music-item">
              <button onClick={() => {
                window.open(
                  "https://www.youtube.com/watch?v=h3UgT-np7Rk",
                  "_blank",
                  "noopener,noreferrer"
                );
              }}>
                <img src="https://i.scdn.co/image/ab67616d0000b273426c1adfb6bd27d9f426a21d"></img>
              </button>
              <span class="inverted">parallel</span>
              <sub>how to count one to ten</sub>
            </div>

          </div>



          <h2>Games but no games</h2>
          <hr />
          <div class="media">

            <div class="media-item">
              <img src="teardown.gif"></img>
              <span class="inverted">Teardown</span>
              <div>
                <p>When I first saw Teardown I thought it was a voxel physics sandbox game for modding, but I gave it a shot and found one of the best video game campaigns I've ever played.</p>
                <p>I love the creative problem solving in this game. I love making a plan, creating arrows with spray paint, and then the satisfaction of perfectly executing your heist.</p>
                <p>11/10 game.</p>

              </div>
            </div>


            <div class="media-item">
              <img src="mosa lina.png"></img>
              <span class="inverted">Mosa Lina</span>
              <div>
                <p>I love mosa lina so much. I love that sometimes the levels are just impossible and you have to give up (I am not being sarcastic).</p>
                <p>Multiplayer update was the best update they ever released. Multiplayer makes the game so much funner. I also love the Mosa Lina: Second Layer update where they added 24 new tools. It's literally Mosa Lina 2 and I love it.</p>

              </div>
            </div>

            <div class="media-item">
              <img src="portal.gif"></img>
              <span class="inverted">Portal Series</span>
              <div>
                <p>I have a vivid memory of watching entire several hour playthroughs of Portal 1 as a young child. I specifically watched silent playthroughs because I wanted to fully appreciate the game, and someone talking over it would distract from it.</p>
                <p>Portal 2 is obviously better than Portal 1. I love the story it adds with Cave Johnson and the different cores. I love how absurd Aperture Science is and how thats also explored in the few spinoff games.</p>

              </div>
            </div>


            <div class="media-item">
              <img src="lethal company.gif"></img>
              <span class="inverted">Lethal Company</span>
              <div>
                <p>I love the gameplay loop, I love the story, I love the enemy design, and I love how the tools you are given to survive are intentionally flawed. My favourite enemy in the game is the old bird (the big mech that spawns outside). I love how its integrated into the lore of the game and I absolutely LOVE the sounds it makes. Something about a giant mech flying around and terrorizing anything that moves all while screaming its name really resonates with me</p>

              </div>
            </div>


            <div class="media-item">
              <img src="rouge light deck builder.png"></img>
              <span class="inverted">Rogue Light Deck Builder</span>
              <div>
                <p>This is first and only actual rogue light deck builder to ever be released.</p>
                <p>I love how stupid and simple this game is. The art style is also so amazing, it's inspired me to add baloon-like text to projects I've worked on.</p>

              </div>
            </div>



          </div>

          <h2>Books/movies/shows I enjoy</h2>
          <hr />
          <div class="media">
            <div class="media-item">
              <img src="creed.png"></img>
              <span class="inverted">The Office</span>
              <div>
                <p>The Office is by far my favourite show.</p>
                <p>I probably watch it 2-3 times per year, it's kinda my comfort show.</p>
                <p>Favourite character is Creed, I wish they showed him on camera more</p>

              </div>
            </div>

            <div class="media-item">
              <img src="project hail mary.png"></img>
              <span class="inverted">Project Hail Mary</span>
              <div>
                <p>This is my favourite book.</p>
                <p>Watched the movie when it came out and it did the book justice, but of course the book is still better.</p>
                <p>I love rocky so much</p>
              </div>
            </div>

            <div class="media-item">
              <img src="heated rivalry.gif"></img>
              <span class="inverted">Heated Rivalry</span>
              <div>
                <p>My thoughts about this show could not fit here 😭</p>
                <p>I love this show a lot and I can't wait for season 2.</p>
                <p>It would be nice, but very unlikely, if they released a clean cut so I could recommend friends watch it without them calling me a freak</p>
              </div>
            </div>

            <div class="media-item">
              <img src="severance.png"></img>
              <span class="inverted">Severance</span>
              <div>
                <p>
                  Severance is a great show. Honestly I think season 1 was better than season 2. In my opinion season 2 should've been the end of the show. They had a great setup for the ending but Apple probably wanted to keep milking their golden goose
                </p>
              </div>
            </div>


            {/* <div class="media-item">
              <img src="https://media1.tenor.com/m/s3qM34cMY08AAAAd/walle-pixar.gif"></img>
              <span class="inverted">WALL-E</span>
              <div>
                <p>Gotta be THE best Pixar movie. </p>
                <p>Genuinely never seen a single better robot character design than WALL-E.</p>
                <p>When I was little I played this WALL-E game on the xbox 360 and it was actually so fun</p>
              </div>
            </div> */}

          </div>




          <footer>
            <div class="colour-picker inverted">
              <div>
                <h2 class="inverted" for="base-color-input">click the box to blow up the website -&gt; </h2>

                <input
                  type="color"
                  id="base-color-input"
                  onInput={(event) => { handleColorChange(event.target.value) }}
                  value={backgroundColour} />

                <span class="fake-input"></span>
              </div>
            </div>

            <ul>
              <li>
                <p>No AI was used in the making of this site.</p>

                <a
                  href="https://github.com/skinsshark/skinsshark.github.io"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  This site outright copies Sharon Zheng
                </a>

                <h5>Created Feb 28 2026     |     Last updated Sep 16 2026</h5>
              </li>

            </ul>


          </footer>
        </div>
      </div>

    </main >
  );
}

export default Face



// this code was stolen from https://www.youtube.com/watch?v=7YaWnHVl7Hk
function getLightnessFromHex(hex) {
  hex = hex.replace(/^#/, '')

  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Luminance formula (perceived brightness)
  const brightness = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;

  return +(brightness * 100).toFixed(2);

}


